import { StyleSheet, View, Text } from "react-native";
import { ProductNode, Purchase } from "@datamodel";
import { useLanguage } from "@languageProvider";
import { useTheme } from "@themeProvider";
import { Typography, Spacing, Mixins } from "@styles";

const styles = StyleSheet.create({
    purchaseCardInfo: {
        paddingVertical: Spacing.M - Spacing.S,
    }
})

export const PurchaseInfo = ({purchase=Purchase.model, menu=ProductNode.model, style, ...props}) => {
    const { useColor, useElevation } = useTheme();
    const { translate } = useLanguage();

    const [body, title, statusColor, inputBackground] = useColor([
        'body',
        'title',
        Purchase.getColor(purchase),
        'inputBackground'
    ]);

    const mainProduct = menu[purchase.selection.item.nodeId] || {};
    const leafs = Purchase.getSelectionLeafs(purchase);

    return (<View style={[styles.purchaseCardInfo, style]}>
        <Text numberOfLines={1} style={[Typography.SUBTITLE, { color: title }]}>{mainProduct.name}</Text>
        {
            leafs.map(nodeId => (
                <Text key={nodeId} style={[Typography.BODY, { color: body }]}>{menu[nodeId]?.name}</Text>
            ))
        }

    </View>)
}